module.exports = __webpack_public_path__ + "static/media/日历3@2x.37fdc4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历3@2x.png
// module id = 1376
// module chunks = 0